import React from "react";
import useFullDimensions from "./useFullDimensions";
import BootstrapBreakpointService from "../../Domain/BootstrapBreakpoint/BootstrapBreakpoint.service";
const useBootstrapBreakpoints = (delay) => {
    const { width } = useFullDimensions(delay);
    return React.useMemo(() => BootstrapBreakpointService.getAllBreakpointsForWidth(width), [width]);
};
export default useBootstrapBreakpoints;
